import React from 'react'

function AcademyPage() {
  return (
	<div>AcademyPage</div>
  )
}

export default AcademyPage